export const page = {
	title: "Productos",
	description: "Listado y configuración de artículos vendidos al cliente final.",
	permissionError: "No tienes los permisos",
	addProduct: "Agregar producto",
	bulkImportProducts: "Importar productos en masa",
	batchActions: "Acciones en lote",
	exportAllProducts: "Exportar todos los productos vía Excel",
	editAllProducts: "Editar todos los productos",
	downloadAllProducts: "Descargar tabla con todos los productos",
};
